module.exports = __webpack_public_path__ + "img/floor_UG2.7ab29f95.svg";